export const routes = {
    main: '/',
    tasks: '/tasks',
    friends: '/friends',
    earnings: '/earnings',
    leaderboard: '/leaderboard',
    faq: '/faq',
    userProfile: '/me',
    games: '/games',
    advent: '/advent',
    mines: '/mines',
    profile: '/profile',
    history: '/history',
    battle: '/battle',
    desktop: '/desktop',
    admin: '/admin',
    adminStats: '/admin/stats',
    adminCases: '/admin/cases',
    adminAdvent: '/admin/advent',
    adminUsers: '/admin/users',
    adminTasks: '/admin/tasks',
    adminReferrals: '/admin/referrals',
    adminMarketing: '/admin/marketing',
    adminMines: '/admin/mines',
    adminBattles: '/admin/battles',
    adminTriggers: '/admin/triggers',
    adminLeaderboard: '/admin/leaderboard',
}
